import { API_BASE_URL } from 'core/environments'

export type ShareMode = 'restricted' | 'public'
export type SharedDashboardData = {
  dashboard: { id: number; name: string; description: string | null }
  company: { name: string; logo_url: string | null }
  publication: { number: number; sha256: string; html: string }
  payload: unknown
  share: { mode: ShareMode; expires_at: string }
}

// Public requests never read a token, refresh a session, send cookies, or inject company_id.
export const publicDashboardRequest = async <T>(
  path: string,
  signal?: AbortSignal,
): Promise<T> => {
  const response = await fetch(`${API_BASE_URL}dashboards/shared/${path}`, {
    credentials: 'omit',
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
    signal,
    headers: { Accept: 'application/json' },
  })
  if (!response.ok) throw new Error('shared_dashboard_unavailable')
  const json = await response.json()
  if (json?.success === false || !json?.data)
    throw new Error('shared_dashboard_unavailable')
  return json.data
}

export const readSharedDashboard = async (
  uuid: string,
  mode: ShareMode,
  viewId: string,
  signal?: AbortSignal,
): Promise<SharedDashboardData> => {
  if (mode === 'public')
    return publicDashboardRequest(`${uuid}?view_id=${viewId}`, signal)
  const { APIRequest } = await import('utils/requests')
  const response = await APIRequest({
    path: `dashboards/shared/${uuid}`,
    method: 'GET',
    skipSpoofedCompany: true,
    queryParams: { view_id: viewId },
  })
  if (response?.success === false || !response?.data)
    throw new Error('shared_dashboard_unavailable')
  return response.data
}
